// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"2d29a80c","231":"406d22ec","610":"53e3f1e3","680":"d1450ffb","809":"de541d99"}[chunkId] + ".chunk.js";
};